import React from 'react';
import { getLanguage } from "../../utility/browser"
import axios from "axios";
import { handlePubhubProjectPreviewRedirection } from "./common";
import Breadcrumb from '../Docs/Detail/Breadcrumb';

export default class extends React.Component {

    state = {
        meta: null,
        config: null
    };

    componentDidMount() {
        const { projectType, projectID, projectStatus } = this.props;
        const config = `https://${CONFIG.PUBHUB_DOMAIN}/app/project/config/${projectID}/${projectStatus}/?${Math.random()}`;
        const doc = PubHub.createDocPage({
            container: document.getElementById("devnet-docs-preview"),
            config: {
                "_navTopOffset": 62
            }
        });

        doc.defaultLanguage = getLanguage();


        doc.on("configDataLoaded", (event) => {
            if (event.detail.data.config) {
                this.setState({ config: event.detail.data.config });
            }

            if (event.detail.data.config["include_header"]) {
                const header_html_fragment_url = event.detail.data.meta.location + "header.html";
                axios.get(header_html_fragment_url)
                    .then((res) => {
                        // optimize for performance
                        document.getElementById("devnet-doc-header").innerHTML = res.data;
                    }).catch(() => {});
            }
        });

        handlePubhubProjectPreviewRedirection(doc, projectID);

        doc.onLoad((instance) => {

            try {
                this.setState({
                    meta: instance.instance.store.getState().meta
                });

                // window.AOS.init();

            } catch (e) {

            }
        });

        // doc.router.baseURL = `/pubhub/${projectType}/${projectID}/${projectStatus}/`;
        doc.configURL = config;

        PubHub.env = CONFIG["PUBHUB_ENV"];

        window.doc = this.doc = doc;
    }

    componentWillUpdate(nextProps, nextState) {
        const doc = this.doc;
        const { projectType, projectID, projectStatus } = nextProps;
        if (doc) {
            if (this.props.projectID !== projectID || this.props.projectStatus !== projectStatus) {

                const config = `https://${CONFIG.PUBHUB_DOMAIN}/app/project/config/${projectID}/${projectStatus}/?${Math.random()}`;

                doc.clear();

                doc.router.baseURL = `/pubhub/${projectType}/${projectID}/${projectStatus}/`;
                doc.config = config;
            }
        }
    }

    componentWillUnmount() {
        if (this.doc) {
            doc.clear();
        }
    }

    render() {
        return (
            <div>
                <div id="devnet-doc-header"></div>
                <Breadcrumb meta={this.state.meta} config={this.state.config} />
                <div id="devnet-docs-preview" />
            </div>
        )
    }
}